import { gql } from "lib/apolloClient";

export const updateStaffReviewerMutation = gql`
  mutation entityRelationMapBulkAction(
    $input: EntityRelationMapBulkActionInput!
  ) {
    platform {
      entityRelationMapBulkAction(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateDefaultReviewerMutation = gql`
  mutation upsertOrganizationGlobalConstant(
    $input: [OrganizationConstantInput!]
  ) {
    platform {
      upsertOrganizationGlobalConstant(input: $input) {
        id
        name
        value
      }
    }
  }
`;
